module.exports = __webpack_public_path__ + "static/media/undraw_healthy_options_sdo3.33b94b09.svg";